import { render, staticRenderFns } from "./CalendarsTab.vue?vue&type=template&id=1725049c"
import script from "./CalendarsTab.vue?vue&type=script&lang=js"
export * from "./CalendarsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports